import { default as CommonTools } from '../utils/common'
import { mercator2lonLat, formatDegree, lonLat2Mercator, lonLatCoordsToMc } from '../utils/tools'
import { BOATS_MODEL_PATH } from '../const'
import { default as mapApp } from '@/map/init.js'
import request from '../../utils/request-common';
/**
 * 船只航道检测
 */
export default class ChannelMapActions {
    constructor(map) {
        this.map = map

        this.floor = null
        this.imageLayer = null
        this.polyLayer = null
        this.lineEffectLayer = null

        this.isInitComplete = false
        this.routeData = []
        this.seaRouteLineNames = [];

        // 航线气泡
        this.routePopVueComponents = []
        this.routePopData = []
        this.routePopMarkerList = []
        // 海底气泡
        this.seabedPopVueComponent = null
        this.seabedPopMarker = null

        this.isSeabedShow = false
        // 导航设施
        this.navPopVueComponents = []
        this.navPopData = []
        this.navPopMarkerList = []
        // 气象检测
        this.weaPopVueComponents = []
        this.weaPopData = []
        this.weaPopMarkerList = []

        // 回旋水域点集
        this.convoluteData = [];

        //航道气泡点位数组
        this.boatRoutePointsData = null
    }

    // 外部初始化
    init () {
        if (this.isInitComplete) {
            this.resetView()
            // TODO:

            return
        }
        this._init()
        this.isInitComplete = true
        this.loadActionData()
    }

    // 内部首次初始化层对象至地图
    _init () {
        // 获取层
        this.floor = this.map.getBuildingById(0).getFloor(1)
        // layer name 都填上好对应交互名称(建议唯一)，方便以后全局查找层对象
        //创建普通标注层
        this.imageLayer = this.floor.getOrCreateLayerByName('boatsImg', esmap.ESLayerType.IMAGE_MARKER)
        this.modelLayer = this.floor.getOrCreateLayerByName('boatsModel', esmap.ESLayerType.MODEL3D)
        this.polyLayer = this.floor.getOrCreateLayerByName('boatsPoly', esmap.ESLayerType.POLYGON_MARKER)
        this.textLayer = this.floor.getOrCreateLayerByName('convolute_text', esmap.ESLayerType.TEXT_MARKER)

        //创建特效标注层
        this.lineEffectLayer = new esmap.ESEffectTool.EffectLayer('boatsLine', esmap.ESLayer.EFFECT_MARKER)

        this.floor.addLayer(this.imageLayer);
        this.floor.addLayer(this.modelLayer);
        esmap.ESEffectTool.addLayerToMap(this.lineEffectLayer)
    }

    // 重置视角
    resetView () {
        mapApp.mapContainer.clickShadeSign = true
        this.map.cameraFlyTo({
            directionAngle: 325.4,
            pitchAngle: 51.25,
            radius: 1618.96,
            time: 3,
            x: 13150575.67,
            y: 4749618.7,
            z: 0,
            callback: function () {
                mapApp.mapContainer.clickShadeSign = false
            }
        })
    }

    // 管理地图点击
    managerMapClick (e) {
        let self = this
        if (e.name && typeof e.name === "string" && e.name === "海底地形") {
            self.map.selectModelNull();
            self.map.options.showTapTip = false;
            setTimeout(() => {
                self.map.options.showTapTip = true
            }, 0);
            if (self.isSeabedShow === true) {
                self.updateSeabedPopMarker(e)
            }
        }
    }

    // 加载当前交互模块基础配置数据
    loadActionData () {
        let that = this
        esmap.ESJsonFileLoader('./assets/actions/channel.json').then((data) => {
            that.routeData = data.boatRoutes;
            // let routePopCoords = [data.boatRoutes[0].routeData[6], data.boatRoutes[0].routeData[8], data.boatRoutes[0].routeData[10]]
            // that.routePopData = routePopCoords;
            that.navPopData = data.navPopMarkersData
            that.weaPopData = data.weaPopMarkersData
        })
    }

    // 航道航线初始化视角
    setRoutesMenuView () {
        mapApp.mapContainer.clickShadeSign = true
        this.map.cameraFlyTo({
            "directionAngle": 348.01, "pitchAngle": 54.74, "radius": 1074.05, "x": 13150649.55, "y": 4749515.87, "z": 0, "time": 2,
            callback: function () {
                mapApp.mapContainer.clickShadeSign = false
            }
        })
    }

    // 海上航线视角
    setBoatRoutesView () {
        mapApp.mapContainer.clickShadeSign = true
        this.map.cameraFlyTo({
            "directionAngle": 329.17, "pitchAngle": 24.33, "radius": 1318.66, "x": 13150565.84, "y": 4749395.28, "z": 0, "time": 2,
            callback: function () {
                mapApp.mapContainer.clickShadeSign = false
            }
        })
    }

    /**
     * 展示某指定船只固定航线和实际航线
     */
    showBoatRouteEffect () {
        this.setBoatRouteExtents();
    }

    // 设置船移动
    setBoatMove (data) {
        let self = this
        let boatMarker = CommonTools.addModelMarker({
            id: "line_boat",
            name: "line_boat",
            x: 0,
            y: 0,
            offsetHeight: 0,
            url: BOATS_MODEL_PATH + data.url,
            size: data.size,
            angle: data.angle,
            callback: function (marker) {
                boatMarker.glow({
                    color: '#ff0000',  //设置报警光圈颜色
                    height: 3,   //设置报警光圈高度
                    scale: 50 //设置报警光圈效果大小
                });
                let curDirection = 0;
                // 补点
                marker.movePath({
                    // 将配置绑定至marker对象中
                    speed: 10, //速度
                    loop: true, //是否循环s
                    loopReverse: true, // 是否反向循环
                    path: data.movePoints, //路径点集
                    startPathIndex: 8, // 指定路径点集中的下标所对应的坐标作为运动起始位置
                    minViewDistance: 20, // 设定跟随视角最小缩放距离
                    maxViewDistance: 100, // 设定跟随视角最大缩放距离
                    followPosition: false, //第一人称视角，跟随移动位置
                    // followScaleLevel: 1, //第一人称视角，跟随缩放地图大小
                    // viewTiltAngle: self.map.maxPolarAngle,//第一人称视角，地图俯仰角
                    followAngle: false, //第一人称视角，根据路径来动态变换地图角度
                    offsetHeight: data.offsetHeight + 4,
                    orientToPath: true, //物体移动时是否沿向路径方向
                    angle: data.angle, //物体移动沿向路径方向的角度
                    complete: function () { },
                    onMoving (e) { // TODO: 待添加船身的上下起伏（正弦函数）
                        // marker.o3d_.position.y += Math.random() * 0.1;
                        // lineMarker1.updatePassPercent(Math.abs(e.progress))
                    }
                })
            },
        })
        this.modelLayer.addMarker(boatMarker)
    }

    /**
     * 设置船只路线区域
     */
    setBoatRouteExtents () {
        esmap.ESJsonFileLoader('./data/boats/sea-routes.json').then((data) => {
            // console.log(data)
            // 航道中心线
            let boatRoutesData = data.features[1];
            // 标注点
            this.boatRoutePointsData = data.features[0];
            // 船路径范围
            let boatRouteExtentData = data.features[2];
            // console.log(boatRoutePointsData)
            console.log(boatRouteExtentData)

            this.createRoutesCenterLine(boatRoutesData);//创建中心线
            this.createRoutePointsPopMarkers();//创建航道气泡

            let extentTypes = [
                { name: "航道范围", color: '#00E4FF' },
                { name: "港池", color: '#f44336' },
                { name: "连接水域", color: '#ff9800' },
            ]
            for (let i = 0; i < extentTypes.length; i++) {
                let coords = lonLatCoordsToMc(boatRouteExtentData.geometry.coordinates[i][0]);
                // 泊位多边形 marker
                let marker = new esmap.ESPolygonMarker({
                    id: extentTypes[i].name,
                    //设置颜色
                    color: extentTypes[i].color,
                    //设置透明度
                    alpha: 0.1,
                    //设置边框线的宽度
                    lineWidth: 15,
                    lineType: esmap.ESLineType.DOT_DASH,
                    //设置高度
                    height: -1,
                    points: coords,
                    seeThrough: true
                })
                this.polyLayer.addMarker(marker);
            }
        })
    }

    // 创建航道线点集弹窗
    createRoutePointsPopMarkers () {
        if (!this.routePopVueComponents || this.routePopVueComponents.length == 0 || !this.boatRoutePointsData) return;
        let self = this;
        let list = this.boatRoutePointsData.geometry.coordinates;
        for (let i = 0; i < list.length; i++) {
            let mc = lonLat2Mercator(list[i][0], list[i][1]);
            let popMarker = CommonTools.addPopMarker({
                x: mc[0], y: mc[1],
                offset: 0,
                showLevel: 17,
            })
            self.routePopMarkerList.push(popMarker);
            let index = self.routePopMarkerList.length - 1;
            self.routePopMarkerList[index].onUpdatePosition((transformStyle, displayStyle) => {
                self.routePopVueComponents[index].popTips.transformStyle = transformStyle
                self.routePopVueComponents[index].popTips.visible = (displayStyle.display == 'none') ? false : true;
            })
        }
    }

    // 创建航道中心线
    createRoutesCenterLine (data) {
        for (let i = 0; i < data.geometry.coordinates.length; i++) {
            let lineCoords = lonLatCoordsToMc(data.geometry.coordinates[i]);
            for (let j = 0; j < lineCoords.length; j++) {
                lineCoords[j].offset = 0;
            }
            let lineMarker = CommonTools.addNavLineMarker({
                id: "center_route" + i,
                color: '#00ff00',
                lineWidth: 4,
                alpha: 0.2,
                points: lineCoords,
                fixedWidth: true,
                transparent: true,
                lineType: esmap.ESLineType.ARROW,
            })
            this.map.drawLineMark(lineMarker)
            this.seaRouteLineNames.push(lineMarker.ID);
        }
    }

    // 关闭路线气泡弹窗
    closeRoutePop () {
        // 清除气泡对象
        if (this.routePopMarkerList.length > 0) {
            for (let marker of this.routePopMarkerList) {
                if (marker) marker.close()
            }
        }
        this.routePopMarkerList = []
        // 清除 vue 气泡组件引用( vue 组件销毁)
        for (let popVueCom of this.routePopVueComponents) {
            if (popVueCom) popVueCom.popTips.visible = false
        }
    }

    // 海上航线视角
    setSeabedView () {
        mapApp.mapContainer.clickShadeSign = true
        this.map.cameraFlyTo({
            "directionAngle": 274.58, "pitchAngle": 48.63, "radius": 1074.05, "x": 13151040.82, "y": 4749866.46, "z": 0, "time": 2,
            callback: function () {
                mapApp.mapContainer.clickShadeSign = false
            }
        })
    }

    // 设置俯瞰所有船只视角
    setAllBoatsView () {
        mapApp.mapContainer.clickShadeSign = true
        this.map.cameraFlyTo({
            "directionAngle": 359.05, "pitchAngle": 40.27, "radius": 58593.75, "x": 13126965.35, "y": 4720154.1, "z": 0, "time": 3,
            callback: function () {
                mapApp.mapContainer.clickShadeSign = false
            }
        })
    }

    showSeabedEffect (config) {
        this.isSeabedShow = true
        esmap.ESEffectTool.water.setStyle('sea_water', { alpha: 0.3 }) // 透明海面
        if (config.isCustomColor) {
            esmap.ESEffectTool.models.setTerrainGradientConfig({ name: 'sea_ground', colorArray: config.colorArray })
        }
        esmap.ESEffectTool.models.showTerrainGradient({
            name: 'sea_ground',
            isShow: true
        })
    }
    //创建海底地形的点击气泡
    showSeabedPopMarker () {
        let that = this
        this.seabedPopMarker = CommonTools.addPopMarker({
            x: 13151625.988003284,
            y: 4750091.707444602
        })
        this.seabedPopMarker.onUpdatePosition(function (transformStyle, displayStyle) {
            that.seabedPopVueComponent.popTips.transformStyle = transformStyle
            that.seabedPopVueComponent.popTips.visible = (displayStyle.display === 'none') ? false : true
        })
    }

    coordChange (x, y) {
        let tempAry = mercator2lonLat(x, y)

        let longAry = formatDegree(tempAry[0])
        let longString = `${longAry[0]}°${longAry[1]}'${longAry[2]}"`

        let latAry = formatDegree(tempAry[1])
        let latString = `${latAry[0]}°${latAry[1]}'${latAry[2]}"`

        return [longString, latString]
    }

    async updateSeabedPopMarker (e) {
        let hitCoord = {
            x: e.hitCoord.x,
            y: e.hitCoord.y,
            z: e.hitCoord.z
        }

        if (this.seabedPopMarker) {
            this.seabedPopVueComponent.display = true
            let tempAry = this.coordChange(hitCoord.x, hitCoord.y)
            this.seabedPopVueComponent.longitude = tempAry[0]
            this.seabedPopVueComponent.latitude = tempAry[1]
            this.seabedPopMarker.moveTo({ x: hitCoord.x, y: hitCoord.y, z: hitCoord.z, time: 0 })

            try {
                let lonLatAry = mercator2lonLat(hitCoord.x, hitCoord.y)
                // console.log("点击位置经纬度:",lonLatAry)
                const { data } = await request('fn/waterDepth', { lon: lonLatAry[0], lat: lonLatAry[1] })
                if (JSON.stringify(data.data) === '{}') {
                    var depth = 'XXX'
                    var waterDepth = 'XXX'
                    var message = data.message
                } else {
                    // 水下地形弹窗，水深加上潮位
                    // var depth = data.data.meanDepth
                    var depth = data.data.actualDepth
                    var waterDepth = data.data.meanDepth
                }
                this.seabedPopVueComponent.message = message || ''
                this.seabedPopVueComponent.depth = depth // 水深带潮位
                this.seabedPopVueComponent.waterDepth = waterDepth // 水深不带潮位，相对于理论最低潮面

            } catch (error) {
                console.log(error)
            }



        }
    }

    closeSeabedPop () {
        this.isSeabedShow = false

        if (this.seabedPopMarker)
            this.seabedPopMarker.close()

        if (this.seabedPopVueComponent)
            this.seabedPopVueComponent.popTips.visible = false
        this.seabedPopVueComponent.display = false
    }

    showNavPopMarker () {
        let that = this
        mapApp.mapContainer.clickShadeSign = true
        this.map.cameraFlyTo({
            "directionAngle": 354.31, "pitchAngle": 79.65, "radius": 1618.96, "x": 13149226.34, "y": 4748500.45, "z": 0, "time": 3,
            callback: function () {
                for (let i = 0; i < that.navPopData.length; i++) {
                    that.navPopMarkerList.push(CommonTools.addPopMarker(that.navPopData[i]))
                    that.navPopMarkerList[i].onUpdatePosition(function (transformStyle, displayStyle) {
                        that.navPopVueComponents[i].popTips.transformStyle = transformStyle
                        that.navPopVueComponents[i].popTips.visible = (displayStyle.display === 'none') ? false : true
                    })
                }
                mapApp.mapContainer.clickShadeSign = false
            }
        })
    }

    closeNavPop () {
        // 清除气泡对象
        if (this.navPopMarkerList.length > 0) {
            for (let marker of this.navPopMarkerList) {
                if (marker) marker.close()
            }
        }
        this.navPopMarkerList = []
        // 清除 vue 气泡组件引用( vue 组件销毁)
        for (let popVueCom of this.navPopVueComponents) {
            if (popVueCom) popVueCom.popTips.visible = false
        }
    }

    flySpecificPlace () {
        mapApp.mapContainer.clickShadeSign = true
        this.map.cameraFlyTo({
            directionAngle: 298.71,
            pitchAngle: 49.96,
            radius: 1618.96,
            time: 2,
            x: 13151272.29,
            y: 4749875.09,
            z: 0,
            callback: function () {
                mapApp.mapContainer.clickShadeSign = true
            }
        })
    }

    clearMarkers () {
        if (this.modelLayer) this.modelLayer.removeAll();
        if (this.imageLayer) this.imageLayer.removeAll();
    }

    //单独拆分清除海上航线的标注、气泡和路线
    clearPolyLayer () {
        if (this.polyLayer) this.polyLayer.removeAll();
        if (this.textLayer) this.textLayer.removeAll()
        this.closeRoutePop()
        for (let ln of this.seaRouteLineNames) {
            this.map.clearLineMarkById(ln);
        }
        this.seaRouteLineNames.length = 0;

    }

    closePageAllPop () {
        this.closeSeabedPop()
        this.closeNavPop()
    }

    clearAllEffect () {
        // this.map.clearLineMarkById('ragular_route');
        // this.map.clearLineMarkById('temp_route');

        // this.map.clearAllLineMark();
        this.clearMarkers();
        esmap.ESEffectTool.water.setStyle('sea_water', { alpha: 1 })
        esmap.ESEffectTool.models.showTerrainGradient({ name: 'sea_ground', isShow: false })
        this.closeSeabedPop()
        this.closeNavPop()

    }
    // 创建多边形 marker
    addPolygonMarker (coords) {
        return new esmap.ESPolygonMarker({
            //设置颜色
            color: '#51d3fe',
            //设置透明度
            alpha: 0.4,
            //设置边框线的宽度
            lineWidth: 15,
            lineType: esmap.ESLineType.DOT_DASH,
            //设置高度
            height: -3,
            points: coords,
            seeThrough: false
        })
    }
    // 添加回旋水域文字标注
    addConvoluteTextMarker (data) {
        let marker = CommonTools.addTextMarker({
            id: 'convolute' + data.dataID,
            name: data.name,
            x: data.x,
            y: data.y,
            text: data.dataID,
            offsetHeight: 2,
            fontsize: 25,
            scale: 50,
            seeThrough: true,
            showLevel: 17,
            // color: '28,62,92'
        })
        this.textLayer.addMarker(marker)
    }
    //显示回旋水域多边形
    showConvolutePop () {
        this.convoluteData.forEach(e => {
            let polygonMarker = this.addPolygonMarker(e.points)
            let centerPos = polygonMarker.getCenter();
            this.addConvoluteTextMarker({ name: e.name, x: centerPos.x, y: centerPos.y, dataID: e.dataID });
            this.polyLayer.addMarker(polygonMarker)
        })
    }

}
